<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="base-card">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.base-card {
  background-color: white;
  border-radius: $base-border-radius-md;
  box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.08);
  margin-bottom: 1.6rem;
  min-height: 22.6rem;
  padding: 2.5rem 0;

  hr {
    margin-bottom: 2.5rem;
  }
}
</style>
